import Relay from 'react-relay'
import Overlay from './Overlay'
import ToggleOverlayMutation from '../../mutations/ToggleOverlayMutation'
import ObjectSlider from '../Object/Slider'
import {getCurrentLanguage} from '../../localData';
import settings from '../../../config/settings';

const OverlayContainer = Relay.createContainer(Overlay, {
    initialVariables: {
        id: 1,
        lang: getCurrentLanguage() || settings.defaultLanguage,
    },
    fragments: {
        store: () => Relay.QL`
            fragment on Store {
                id,
                overlayObjId,
                isOverlayVisible,
                ${ToggleOverlayMutation.getFragment('store')},
                ${ObjectSlider.getFragment('store')}
                object(id: $id, lang: $lang) {
                    id,
                    ${ObjectSlider.getFragment('object')}
                    ObjMultimediaCount,
                    ObjMultimediaWidths,
                }
            }
        `
    }
});

export default OverlayContainer;


// WEBPACK FOOTER //
// ./app/components/Overlay/index.js